import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

export const Seo = ({ description, lang, meta, keywords, title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`${site.siteMetadata.title}`}
      defaultTitle={title}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: site.siteMetadata.title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:url',
          content: 'https://blissful-torvalds-173b96.netlify.com/',
        },
        {
          property: 'og:image',
          content:
            'https://images.ctfassets.net/wcgx4o777n3f/73ZyCH7JEf7L6HOTtX8hje/29c9ef5432efebce6b014757e41b1179/poz_logo-icon.png?w=64&h=64&q=100',
        },
        {
          property: 'og:locale',
          content: 'en_US',
        },
        {
          property: 'og:site_name',
          content: 'Pozitiff',
        },
        {
          property: 'og:image:width',
          content: '64',
        },
        {
          property: 'og:image:height',
          content: '64',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: site.siteMetadata.author,
        },
        {
          name: 'twitter:title',
          content: site.siteMetadata.title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'twitter:image',
          content:
            'https://images.ctfassets.net/wcgx4o777n3f/73ZyCH7JEf7L6HOTtX8hje/29c9ef5432efebce6b014757e41b1179/poz_logo-icon.png?w=64&h=64&q=100',
        },
        {
          name: 'twitter:site',
          content: 'https://blissful-torvalds-173b96.netlify.com/',
        },
        {
          name: 'keywords',
          content: keywords.join(', '),
        },
      ].concat(meta)}
    />
  )
}

Seo.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: [],
  description: '',
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}
